"use client";

import createIcon from './util/createIcon';
export default createIcon('M9,5V10C13.03,12.47 8.44,14.97 6,16V19H21V16C14.59,13.27 17.47,9 22,8V5H9M2,6C2.81,8.13 4.42,9.5 7,10V6H2Z', 'Anvil');